"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPENSATION_ADJUSTMENT_ADDED_EVENT_TYPE = exports.COMPENSATION_CALCULATION_APPROVED_EVENT_TYPE = exports.PAYMENT_DISPUTE_ACTION_REQUIRED_EVENT_TYPE = exports.PAYMENT_DISPUTE_UPDATED_EVENT_TYPE = exports.PAYMENT_RECONCILIATION_REQUIRED_EVENT_TYPE = exports.PAYMENT_REFUND_FAILED_EVENT_TYPE = exports.PAYMENT_FAILED_EVENT_TYPE = exports.PAYMENT_REVERSED_EVENT_TYPE = exports.PAYMENT_RECORDED_EVENT_TYPE = exports.INVOICE_PAID_EVENT_TYPE = exports.INVOICE_DELIVERY_FAILED_EVENT_TYPE = exports.INVOICE_DELIVERED_EVENT_TYPE = exports.INVOICE_SENT_EVENT_TYPE = exports.INVOICE_DELIVERY_QUEUED_EVENT_TYPE = exports.INVOICE_VIEWED_EVENT_TYPE = exports.SERVICE_LOCATION_UPDATED_EVENT_TYPE = exports.SCHEDULE_EVENT_ADDRESS_UPDATED_EVENT_TYPE = exports.TECHNICIAN_LOCATION_CHANGED_EVENT_TYPE = exports.SCHEDULE_EVENT_CREATED_EVENT_TYPE = exports.APPOINTMENT_RESCHEDULED_EVENT_TYPE = exports.APPOINTMENT_STATUS_CHANGED_EVENT_TYPE = exports.APPOINTMENT_ASSIGNED_EVENT_TYPE = exports.APPOINTMENT_CREATED_EVENT_TYPE = exports.JOB_ATTACHMENT_REMOVED_EVENT_TYPE = exports.JOB_ATTACHMENT_ADDED_EVENT_TYPE = exports.JOB_LINE_ITEMS_CHANGED_EVENT_TYPE = exports.PENDING_JOB_PIPELINE_SCHEDULED_EVENT_TYPE = exports.PENDING_JOB_PIPELINE_REMINDER_DUE_EVENT_TYPE = exports.PENDING_JOB_PIPELINE_STAGE_CHANGED_EVENT_TYPE = exports.PENDING_JOB_PIPELINE_ITEM_UPDATED_EVENT_TYPE = exports.PENDING_JOB_PIPELINE_ITEM_CREATED_EVENT_TYPE = exports.JOB_STATUS_CHANGED_EVENT_TYPE = exports.JOB_UPDATED_EVENT_TYPE = exports.JOB_CREATED_FROM_ESTIMATE_EVENT_TYPE = exports.JOB_CREATED_EVENT_TYPE = exports.GOOGLE_BOOKING_PUBLICATION_SYNC_REQUESTED_EVENT_TYPE = exports.ONLINE_BOOKING_EMBED_CONFIGURATION_UPDATED_EVENT_TYPE = exports.ONLINE_BOOKING_SETTINGS_UPDATED_EVENT_TYPE = exports.ONLINE_BOOKING_CONFIGURATION_PUBLISHED_EVENT_TYPE = exports.ONLINE_BOOKING_SERVICE_AREA_UPDATED_EVENT_TYPE = exports.ORGANIZATION_LOCATION_ACCESS_UPDATED_EVENT_TYPE = exports.BUSINESS_LOCATION_RESTORED_EVENT_TYPE = exports.BUSINESS_LOCATION_ARCHIVED_EVENT_TYPE = exports.BUSINESS_LOCATION_DEFAULT_CHANGED_EVENT_TYPE = exports.BUSINESS_LOCATION_UPDATED_EVENT_TYPE = exports.BUSINESS_LOCATION_CREATED_EVENT_TYPE = exports.BUSINESS_LOCATION_MANAGEMENT_UPDATED_EVENT_TYPE = exports.BUSINESS_UPDATED_EVENT_TYPE = exports.BUSINESS_CREATED_EVENT_TYPE = exports.integrationEventEnvelopeSchema = void 0;
exports.COMMUNICATION_CONVERSATION_UPDATED_EVENT_TYPE = exports.COMMUNICATION_MESSAGE_FAILED_EVENT_TYPE = exports.COMMUNICATION_MESSAGE_DELIVERED_EVENT_TYPE = exports.COMMUNICATION_MESSAGE_SENT_EVENT_TYPE = exports.COMMUNICATION_MESSAGE_QUEUED_EVENT_TYPE = exports.COMMUNICATION_MESSAGE_RECEIVED_EVENT_TYPE = exports.MESSAGE_DELIVERY_FAILED_EVENT_TYPE = exports.MESSAGE_DELIVERED_EVENT_TYPE = exports.MESSAGE_SENT_EVENT_TYPE = exports.MESSAGE_RECEIVED_EVENT_TYPE = exports.MESSAGE_SEND_REQUESTED_EVENT_TYPE = exports.CONVERSATION_LINKED_EVENT_TYPE = exports.CONVERSATION_STATUS_CHANGED_EVENT_TYPE = exports.CONVERSATION_ASSIGNED_EVENT_TYPE = exports.CONVERSATION_CREATED_EVENT_TYPE = exports.JOB_INBOX_ITEM_CONVERTED_EVENT_TYPE = exports.JOB_INBOX_ITEM_STATUS_CHANGED_EVENT_TYPE = exports.JOB_INBOX_ITEM_ASSIGNED_EVENT_TYPE = exports.JOB_INBOX_ITEM_RECEIVED_EVENT_TYPE = exports.LEAD_ARCHIVED_EVENT_TYPE = exports.LEAD_CONVERTED_EVENT_TYPE = exports.LEAD_ASSIGNED_EVENT_TYPE = exports.LEAD_STATUS_CHANGED_EVENT_TYPE = exports.LEAD_UPDATED_EVENT_TYPE = exports.LEAD_CREATED_EVENT_TYPE = exports.TEAM_WORKING_HOURS_UPDATED_EVENT_TYPE = exports.TEAM_MEMBER_PROFILE_UPDATED_EVENT_TYPE = exports.TEAM_MEMBER_STATUS_CHANGED_EVENT_TYPE = exports.TEAM_MEMBER_CAPABILITIES_CHANGED_EVENT_TYPE = exports.TEAM_MEMBER_ROLE_CHANGED_EVENT_TYPE = exports.TEAM_INVITATION_ACCEPTED_EVENT_TYPE = exports.TEAM_MEMBER_INVITED_EVENT_TYPE = exports.SERVICE_LOCATION_CREATED_EVENT_TYPE = exports.CUSTOMER_CONTACT_ARCHIVED_EVENT_TYPE = exports.CUSTOMER_CONTACT_UPDATED_EVENT_TYPE = exports.CUSTOMER_CONTACT_CREATED_EVENT_TYPE = exports.CUSTOMER_ARCHIVED_EVENT_TYPE = exports.CUSTOMER_UPDATED_EVENT_TYPE = exports.CUSTOMER_CREATED_EVENT_TYPE = exports.PRICE_BOOK_VERSION_SCHEDULED_EVENT_TYPE = exports.PRICE_BOOK_VERSION_PUBLISHED_EVENT_TYPE = exports.CATALOG_ITEM_RESTORED_EVENT_TYPE = exports.CATALOG_ITEM_ARCHIVED_EVENT_TYPE = exports.CATALOG_ITEM_UPDATED_EVENT_TYPE = exports.CATALOG_ITEM_CREATED_EVENT_TYPE = exports.PREPAYMENT_CANCELED_EVENT_TYPE = exports.PREPAYMENT_APPLIED_EVENT_TYPE = exports.PREPAYMENT_COLLECTION_REVERSED_EVENT_TYPE = exports.PREPAYMENT_COLLECTED_EVENT_TYPE = exports.PREPAYMENT_CREATED_EVENT_TYPE = void 0;
exports.voiceTrackingNumberUpdatedEventDataSchema = exports.googleLsaSyncFailedEventDataSchema = exports.googleLsaSyncCompletedEventDataSchema = exports.googleLsaConnectionUpdatedEventDataSchema = exports.pendingJobPipelineEventDataSchema = exports.compensationEventDataSchema = exports.onlineBookingEmbedConfigurationUpdatedEventDataSchema = exports.googleBookingPublicationSyncRequestedEventDataSchema = exports.onlineBookingSettingsUpdatedEventDataSchema = exports.onlineBookingConfigurationPublishedEventDataSchema = exports.onlineBookingServiceAreaUpdatedEventDataSchema = exports.organizationLocationAccessUpdatedEventDataSchema = exports.coreIntegrationEventTypeSchema = exports.builtInIntegrationEventTypeSchema = exports.CORE_INTEGRATION_EVENT_TYPES = exports.BUILT_IN_INTEGRATION_EVENT_TYPES = exports.CORE_OPERATIONAL_INTEGRATION_EVENT_TYPES = exports.COMPENSATION_INTEGRATION_EVENT_TYPES = exports.SERVICE_PLAN_INTEGRATION_EVENT_TYPES = exports.VOICE_INTEGRATION_EVENT_TYPES = exports.GOOGLE_LSA_INTEGRATION_EVENT_TYPES = exports.COMMUNICATION_INTEGRATION_EVENT_TYPES = exports.CONVERSATION_INTEGRATION_EVENT_TYPES = exports.JOB_INBOX_INTEGRATION_EVENT_TYPES = exports.LEAD_INTEGRATION_EVENT_TYPES = exports.TEAM_LIFECYCLE_INTEGRATION_EVENT_TYPES = exports.TEAM_INTEGRATION_EVENT_TYPES = exports.CUSTOMER_INTEGRATION_EVENT_TYPES = exports.CATALOG_INTEGRATION_EVENT_TYPES = exports.INVOICE_DELIVERY_INTEGRATION_EVENT_TYPES = exports.SCHEDULE_INTEGRATION_EVENT_TYPES = exports.PENDING_JOB_PIPELINE_INTEGRATION_EVENT_TYPES = exports.JOB_APPOINTMENT_INTEGRATION_EVENT_TYPES = exports.ONLINE_BOOKING_INTEGRATION_EVENT_TYPES = exports.ORGANIZATION_INTEGRATION_EVENT_TYPES = exports.BUSINESS_INTEGRATION_EVENT_TYPES = exports.SERVICE_PLAN_OCCURRENCE_GENERATED_EVENT_TYPE = exports.SERVICE_PLAN_OCCURRENCE_DUE_EVENT_TYPE = exports.SERVICE_PLAN_ENROLLMENT_STATUS_CHANGED_EVENT_TYPE = exports.SERVICE_PLAN_ENROLLMENT_CREATED_EVENT_TYPE = exports.SERVICE_PLAN_TEMPLATE_STATUS_CHANGED_EVENT_TYPE = exports.SERVICE_PLAN_TEMPLATE_CREATED_EVENT_TYPE = exports.VOICE_TRACKING_NUMBER_UPDATED_EVENT_TYPE = exports.VOICE_VOICEMAIL_RECORDING_READY_EVENT_TYPE = exports.GOOGLE_LSA_SYNC_FAILED_EVENT_TYPE = exports.GOOGLE_LSA_SYNC_COMPLETED_EVENT_TYPE = exports.GOOGLE_LSA_CONNECTION_UPDATED_EVENT_TYPE = void 0;
exports.parseBuiltInIntegrationEventData = parseBuiltInIntegrationEventData;
exports.parseBuiltInIntegrationEvent = parseBuiltInIntegrationEvent;
const zod_1 = require("zod");
exports.integrationEventEnvelopeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: zod_1.z.string().regex(/^[a-z][a-z0-9_]*(?:\.[a-z0-9_]+)+\.v[1-9][0-9]*$/),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
    tenantId: zod_1.z.string().uuid(),
    data: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
});
exports.BUSINESS_CREATED_EVENT_TYPE = "business.created.v1";
exports.BUSINESS_UPDATED_EVENT_TYPE = "business.updated.v1";
exports.BUSINESS_LOCATION_MANAGEMENT_UPDATED_EVENT_TYPE = "business.location_management_updated.v1";
exports.BUSINESS_LOCATION_CREATED_EVENT_TYPE = "business.location_created.v1";
exports.BUSINESS_LOCATION_UPDATED_EVENT_TYPE = "business.location_updated.v1";
exports.BUSINESS_LOCATION_DEFAULT_CHANGED_EVENT_TYPE = "business.location_default_changed.v1";
exports.BUSINESS_LOCATION_ARCHIVED_EVENT_TYPE = "business.location_archived.v1";
exports.BUSINESS_LOCATION_RESTORED_EVENT_TYPE = "business.location_restored.v1";
exports.ORGANIZATION_LOCATION_ACCESS_UPDATED_EVENT_TYPE = "organization.location_access_updated.v1";
exports.ONLINE_BOOKING_SERVICE_AREA_UPDATED_EVENT_TYPE = "online_booking.service_area_updated.v1";
exports.ONLINE_BOOKING_CONFIGURATION_PUBLISHED_EVENT_TYPE = "online_booking.configuration_published.v1";
exports.ONLINE_BOOKING_SETTINGS_UPDATED_EVENT_TYPE = "online_booking.settings_updated.v1";
exports.ONLINE_BOOKING_EMBED_CONFIGURATION_UPDATED_EVENT_TYPE = "online_booking.embed_configuration_updated.v1";
exports.GOOGLE_BOOKING_PUBLICATION_SYNC_REQUESTED_EVENT_TYPE = "google_booking.publication_sync_requested.v1";
exports.JOB_CREATED_EVENT_TYPE = "job.created.v1";
exports.JOB_CREATED_FROM_ESTIMATE_EVENT_TYPE = "job.created_from_estimate.v1";
exports.JOB_UPDATED_EVENT_TYPE = "job.updated.v1";
exports.JOB_STATUS_CHANGED_EVENT_TYPE = "job.status_changed.v1";
exports.PENDING_JOB_PIPELINE_ITEM_CREATED_EVENT_TYPE = "pending_job_pipeline.item_created.v1";
exports.PENDING_JOB_PIPELINE_ITEM_UPDATED_EVENT_TYPE = "pending_job_pipeline.item_updated.v1";
exports.PENDING_JOB_PIPELINE_STAGE_CHANGED_EVENT_TYPE = "pending_job_pipeline.stage_changed.v1";
exports.PENDING_JOB_PIPELINE_REMINDER_DUE_EVENT_TYPE = "pending_job_pipeline.reminder_due.v1";
exports.PENDING_JOB_PIPELINE_SCHEDULED_EVENT_TYPE = "pending_job_pipeline.scheduled.v1";
exports.JOB_LINE_ITEMS_CHANGED_EVENT_TYPE = "job.line_items_changed.v1";
exports.JOB_ATTACHMENT_ADDED_EVENT_TYPE = "job.attachment_added.v1";
exports.JOB_ATTACHMENT_REMOVED_EVENT_TYPE = "job.attachment_removed.v1";
exports.APPOINTMENT_CREATED_EVENT_TYPE = "appointment.created.v1";
exports.APPOINTMENT_ASSIGNED_EVENT_TYPE = "appointment.assigned.v1";
exports.APPOINTMENT_STATUS_CHANGED_EVENT_TYPE = "appointment.status_changed.v1";
exports.APPOINTMENT_RESCHEDULED_EVENT_TYPE = "appointment.rescheduled.v1";
exports.SCHEDULE_EVENT_CREATED_EVENT_TYPE = "schedule.event_created.v1";
exports.TECHNICIAN_LOCATION_CHANGED_EVENT_TYPE = "technician_location.changed.v1";
exports.SCHEDULE_EVENT_ADDRESS_UPDATED_EVENT_TYPE = "schedule.event_address_updated.v1";
exports.SERVICE_LOCATION_UPDATED_EVENT_TYPE = "service_location.updated.v1";
exports.INVOICE_VIEWED_EVENT_TYPE = "invoice.viewed.v1";
exports.INVOICE_DELIVERY_QUEUED_EVENT_TYPE = "invoice.delivery_queued.v1";
exports.INVOICE_SENT_EVENT_TYPE = "invoice.sent.v1";
exports.INVOICE_DELIVERED_EVENT_TYPE = "invoice.delivered.v1";
exports.INVOICE_DELIVERY_FAILED_EVENT_TYPE = "invoice.delivery_failed.v1";
exports.INVOICE_PAID_EVENT_TYPE = "invoice.paid.v1";
exports.PAYMENT_RECORDED_EVENT_TYPE = "payment.recorded.v1";
exports.PAYMENT_REVERSED_EVENT_TYPE = "payment.reversed.v1";
exports.PAYMENT_FAILED_EVENT_TYPE = "payment.failed.v1";
exports.PAYMENT_REFUND_FAILED_EVENT_TYPE = "payment.refund_failed.v1";
exports.PAYMENT_RECONCILIATION_REQUIRED_EVENT_TYPE = "payment.reconciliation_required.v1";
exports.PAYMENT_DISPUTE_UPDATED_EVENT_TYPE = "payment.dispute_updated.v1";
exports.PAYMENT_DISPUTE_ACTION_REQUIRED_EVENT_TYPE = "payment.dispute_action_required.v1";
exports.COMPENSATION_CALCULATION_APPROVED_EVENT_TYPE = "compensation.calculation_approved.v1";
exports.COMPENSATION_ADJUSTMENT_ADDED_EVENT_TYPE = "compensation.adjustment_added.v1";
exports.PREPAYMENT_CREATED_EVENT_TYPE = "prepayment.created.v1";
exports.PREPAYMENT_COLLECTED_EVENT_TYPE = "prepayment.collected.v1";
exports.PREPAYMENT_COLLECTION_REVERSED_EVENT_TYPE = "prepayment.collection_reversed.v1";
exports.PREPAYMENT_APPLIED_EVENT_TYPE = "prepayment.applied.v1";
exports.PREPAYMENT_CANCELED_EVENT_TYPE = "prepayment.canceled.v1";
exports.CATALOG_ITEM_CREATED_EVENT_TYPE = "catalog.item_created.v1";
exports.CATALOG_ITEM_UPDATED_EVENT_TYPE = "catalog.item_updated.v1";
exports.CATALOG_ITEM_ARCHIVED_EVENT_TYPE = "catalog.item_archived.v1";
exports.CATALOG_ITEM_RESTORED_EVENT_TYPE = "catalog.item_restored.v1";
exports.PRICE_BOOK_VERSION_PUBLISHED_EVENT_TYPE = "price_book.version_published.v1";
exports.PRICE_BOOK_VERSION_SCHEDULED_EVENT_TYPE = "price_book.version_scheduled.v1";
exports.CUSTOMER_CREATED_EVENT_TYPE = "customer.created.v1";
exports.CUSTOMER_UPDATED_EVENT_TYPE = "customer.updated.v1";
exports.CUSTOMER_ARCHIVED_EVENT_TYPE = "customer.archived.v1";
exports.CUSTOMER_CONTACT_CREATED_EVENT_TYPE = "customer_contact.created.v1";
exports.CUSTOMER_CONTACT_UPDATED_EVENT_TYPE = "customer_contact.updated.v1";
exports.CUSTOMER_CONTACT_ARCHIVED_EVENT_TYPE = "customer_contact.archived.v1";
exports.SERVICE_LOCATION_CREATED_EVENT_TYPE = "service_location.created.v1";
exports.TEAM_MEMBER_INVITED_EVENT_TYPE = "team.member_invited.v1";
exports.TEAM_INVITATION_ACCEPTED_EVENT_TYPE = "team.invitation_accepted.v1";
exports.TEAM_MEMBER_ROLE_CHANGED_EVENT_TYPE = "team.member_role_changed.v1";
exports.TEAM_MEMBER_CAPABILITIES_CHANGED_EVENT_TYPE = "team.member_capabilities_changed.v1";
exports.TEAM_MEMBER_STATUS_CHANGED_EVENT_TYPE = "team.member_status_changed.v1";
exports.TEAM_MEMBER_PROFILE_UPDATED_EVENT_TYPE = "team.member_profile_updated.v1";
exports.TEAM_WORKING_HOURS_UPDATED_EVENT_TYPE = "team.working_hours_updated.v1";
exports.LEAD_CREATED_EVENT_TYPE = "lead.created.v1";
exports.LEAD_UPDATED_EVENT_TYPE = "lead.updated.v1";
exports.LEAD_STATUS_CHANGED_EVENT_TYPE = "lead.status_changed.v1";
exports.LEAD_ASSIGNED_EVENT_TYPE = "lead.assigned.v1";
exports.LEAD_CONVERTED_EVENT_TYPE = "lead.converted.v1";
exports.LEAD_ARCHIVED_EVENT_TYPE = "lead.archived.v1";
exports.JOB_INBOX_ITEM_RECEIVED_EVENT_TYPE = "job_inbox.item_received.v1";
exports.JOB_INBOX_ITEM_ASSIGNED_EVENT_TYPE = "job_inbox.item_assigned.v1";
exports.JOB_INBOX_ITEM_STATUS_CHANGED_EVENT_TYPE = "job_inbox.item_status_changed.v1";
exports.JOB_INBOX_ITEM_CONVERTED_EVENT_TYPE = "job_inbox.item_converted.v1";
exports.CONVERSATION_CREATED_EVENT_TYPE = "conversation.created.v1";
exports.CONVERSATION_ASSIGNED_EVENT_TYPE = "conversation.assigned.v1";
exports.CONVERSATION_STATUS_CHANGED_EVENT_TYPE = "conversation.status_changed.v1";
exports.CONVERSATION_LINKED_EVENT_TYPE = "conversation.linked.v1";
exports.MESSAGE_SEND_REQUESTED_EVENT_TYPE = "message.send_requested.v1";
exports.MESSAGE_RECEIVED_EVENT_TYPE = "message.received.v1";
exports.MESSAGE_SENT_EVENT_TYPE = "message.sent.v1";
exports.MESSAGE_DELIVERED_EVENT_TYPE = "message.delivered.v1";
exports.MESSAGE_DELIVERY_FAILED_EVENT_TYPE = "message.delivery_failed.v1";
exports.COMMUNICATION_MESSAGE_RECEIVED_EVENT_TYPE = "communication.message_received.v1";
exports.COMMUNICATION_MESSAGE_QUEUED_EVENT_TYPE = "communication.message_queued.v1";
exports.COMMUNICATION_MESSAGE_SENT_EVENT_TYPE = "communication.message_sent.v1";
exports.COMMUNICATION_MESSAGE_DELIVERED_EVENT_TYPE = "communication.message_delivered.v1";
exports.COMMUNICATION_MESSAGE_FAILED_EVENT_TYPE = "communication.message_failed.v1";
exports.COMMUNICATION_CONVERSATION_UPDATED_EVENT_TYPE = "communication.conversation_updated.v1";
exports.GOOGLE_LSA_CONNECTION_UPDATED_EVENT_TYPE = "google_lsa.connection_updated.v1";
exports.GOOGLE_LSA_SYNC_COMPLETED_EVENT_TYPE = "google_lsa.sync_completed.v1";
exports.GOOGLE_LSA_SYNC_FAILED_EVENT_TYPE = "google_lsa.sync_failed.v1";
exports.VOICE_VOICEMAIL_RECORDING_READY_EVENT_TYPE = "voice.voicemail_recording_ready.v1";
exports.VOICE_TRACKING_NUMBER_UPDATED_EVENT_TYPE = "voice.tracking_number_updated.v1";
exports.SERVICE_PLAN_TEMPLATE_CREATED_EVENT_TYPE = "service_plan.template_created.v1";
exports.SERVICE_PLAN_TEMPLATE_STATUS_CHANGED_EVENT_TYPE = "service_plan.template_status_changed.v1";
exports.SERVICE_PLAN_ENROLLMENT_CREATED_EVENT_TYPE = "service_plan.enrollment_created.v1";
exports.SERVICE_PLAN_ENROLLMENT_STATUS_CHANGED_EVENT_TYPE = "service_plan.enrollment_status_changed.v1";
exports.SERVICE_PLAN_OCCURRENCE_DUE_EVENT_TYPE = "service_plan.occurrence_due.v1";
exports.SERVICE_PLAN_OCCURRENCE_GENERATED_EVENT_TYPE = "service_plan.occurrence_generated.v1";
exports.BUSINESS_INTEGRATION_EVENT_TYPES = [
    exports.BUSINESS_CREATED_EVENT_TYPE,
    exports.BUSINESS_UPDATED_EVENT_TYPE,
    exports.BUSINESS_LOCATION_MANAGEMENT_UPDATED_EVENT_TYPE,
    exports.BUSINESS_LOCATION_CREATED_EVENT_TYPE,
    exports.BUSINESS_LOCATION_UPDATED_EVENT_TYPE,
    exports.BUSINESS_LOCATION_DEFAULT_CHANGED_EVENT_TYPE,
    exports.BUSINESS_LOCATION_ARCHIVED_EVENT_TYPE,
    exports.BUSINESS_LOCATION_RESTORED_EVENT_TYPE,
];
exports.ORGANIZATION_INTEGRATION_EVENT_TYPES = [
    exports.ORGANIZATION_LOCATION_ACCESS_UPDATED_EVENT_TYPE,
];
exports.ONLINE_BOOKING_INTEGRATION_EVENT_TYPES = [
    exports.ONLINE_BOOKING_SERVICE_AREA_UPDATED_EVENT_TYPE,
    exports.ONLINE_BOOKING_CONFIGURATION_PUBLISHED_EVENT_TYPE,
    exports.ONLINE_BOOKING_SETTINGS_UPDATED_EVENT_TYPE,
    exports.ONLINE_BOOKING_EMBED_CONFIGURATION_UPDATED_EVENT_TYPE,
    exports.GOOGLE_BOOKING_PUBLICATION_SYNC_REQUESTED_EVENT_TYPE,
];
exports.JOB_APPOINTMENT_INTEGRATION_EVENT_TYPES = [
    exports.JOB_CREATED_EVENT_TYPE,
    exports.JOB_CREATED_FROM_ESTIMATE_EVENT_TYPE,
    exports.JOB_UPDATED_EVENT_TYPE,
    exports.JOB_STATUS_CHANGED_EVENT_TYPE,
    exports.APPOINTMENT_CREATED_EVENT_TYPE,
    exports.APPOINTMENT_ASSIGNED_EVENT_TYPE,
    exports.APPOINTMENT_STATUS_CHANGED_EVENT_TYPE,
    exports.APPOINTMENT_RESCHEDULED_EVENT_TYPE,
];
exports.PENDING_JOB_PIPELINE_INTEGRATION_EVENT_TYPES = [
    exports.PENDING_JOB_PIPELINE_ITEM_CREATED_EVENT_TYPE,
    exports.PENDING_JOB_PIPELINE_ITEM_UPDATED_EVENT_TYPE,
    exports.PENDING_JOB_PIPELINE_STAGE_CHANGED_EVENT_TYPE,
    exports.PENDING_JOB_PIPELINE_REMINDER_DUE_EVENT_TYPE,
    exports.PENDING_JOB_PIPELINE_SCHEDULED_EVENT_TYPE,
];
exports.SCHEDULE_INTEGRATION_EVENT_TYPES = [
    exports.SCHEDULE_EVENT_ADDRESS_UPDATED_EVENT_TYPE,
    exports.TECHNICIAN_LOCATION_CHANGED_EVENT_TYPE,
    exports.SCHEDULE_EVENT_CREATED_EVENT_TYPE,
];
exports.INVOICE_DELIVERY_INTEGRATION_EVENT_TYPES = [
    exports.INVOICE_DELIVERY_QUEUED_EVENT_TYPE,
    exports.INVOICE_SENT_EVENT_TYPE,
    exports.INVOICE_DELIVERED_EVENT_TYPE,
    exports.INVOICE_DELIVERY_FAILED_EVENT_TYPE,
];
exports.CATALOG_INTEGRATION_EVENT_TYPES = [
    exports.CATALOG_ITEM_CREATED_EVENT_TYPE,
    exports.CATALOG_ITEM_UPDATED_EVENT_TYPE,
    exports.CATALOG_ITEM_ARCHIVED_EVENT_TYPE,
    exports.CATALOG_ITEM_RESTORED_EVENT_TYPE,
    exports.PRICE_BOOK_VERSION_PUBLISHED_EVENT_TYPE,
    exports.PRICE_BOOK_VERSION_SCHEDULED_EVENT_TYPE,
];
exports.CUSTOMER_INTEGRATION_EVENT_TYPES = [
    exports.CUSTOMER_CREATED_EVENT_TYPE,
    exports.CUSTOMER_UPDATED_EVENT_TYPE,
    exports.CUSTOMER_ARCHIVED_EVENT_TYPE,
    exports.CUSTOMER_CONTACT_CREATED_EVENT_TYPE,
    exports.CUSTOMER_CONTACT_UPDATED_EVENT_TYPE,
    exports.CUSTOMER_CONTACT_ARCHIVED_EVENT_TYPE,
    exports.SERVICE_LOCATION_CREATED_EVENT_TYPE,
    exports.SERVICE_LOCATION_UPDATED_EVENT_TYPE,
];
exports.TEAM_INTEGRATION_EVENT_TYPES = [
    exports.TEAM_MEMBER_INVITED_EVENT_TYPE,
];
exports.TEAM_LIFECYCLE_INTEGRATION_EVENT_TYPES = [
    exports.TEAM_INVITATION_ACCEPTED_EVENT_TYPE,
    exports.TEAM_MEMBER_ROLE_CHANGED_EVENT_TYPE,
    exports.TEAM_MEMBER_CAPABILITIES_CHANGED_EVENT_TYPE,
    exports.TEAM_MEMBER_STATUS_CHANGED_EVENT_TYPE,
    exports.TEAM_MEMBER_PROFILE_UPDATED_EVENT_TYPE,
    exports.TEAM_WORKING_HOURS_UPDATED_EVENT_TYPE,
];
exports.LEAD_INTEGRATION_EVENT_TYPES = [
    exports.LEAD_CREATED_EVENT_TYPE,
    exports.LEAD_UPDATED_EVENT_TYPE,
    exports.LEAD_STATUS_CHANGED_EVENT_TYPE,
    exports.LEAD_ASSIGNED_EVENT_TYPE,
    exports.LEAD_CONVERTED_EVENT_TYPE,
    exports.LEAD_ARCHIVED_EVENT_TYPE,
];
exports.JOB_INBOX_INTEGRATION_EVENT_TYPES = [
    exports.JOB_INBOX_ITEM_RECEIVED_EVENT_TYPE,
    exports.JOB_INBOX_ITEM_ASSIGNED_EVENT_TYPE,
    exports.JOB_INBOX_ITEM_STATUS_CHANGED_EVENT_TYPE,
    exports.JOB_INBOX_ITEM_CONVERTED_EVENT_TYPE,
];
exports.CONVERSATION_INTEGRATION_EVENT_TYPES = [
    exports.CONVERSATION_CREATED_EVENT_TYPE,
    exports.CONVERSATION_ASSIGNED_EVENT_TYPE,
    exports.CONVERSATION_STATUS_CHANGED_EVENT_TYPE,
    exports.CONVERSATION_LINKED_EVENT_TYPE,
    exports.MESSAGE_RECEIVED_EVENT_TYPE,
    exports.MESSAGE_SENT_EVENT_TYPE,
    exports.MESSAGE_DELIVERED_EVENT_TYPE,
    exports.MESSAGE_DELIVERY_FAILED_EVENT_TYPE,
];
exports.COMMUNICATION_INTEGRATION_EVENT_TYPES = [
    exports.COMMUNICATION_MESSAGE_RECEIVED_EVENT_TYPE,
    exports.COMMUNICATION_MESSAGE_QUEUED_EVENT_TYPE,
    exports.COMMUNICATION_MESSAGE_SENT_EVENT_TYPE,
    exports.COMMUNICATION_MESSAGE_DELIVERED_EVENT_TYPE,
    exports.COMMUNICATION_MESSAGE_FAILED_EVENT_TYPE,
    exports.COMMUNICATION_CONVERSATION_UPDATED_EVENT_TYPE,
];
exports.GOOGLE_LSA_INTEGRATION_EVENT_TYPES = [
    exports.GOOGLE_LSA_CONNECTION_UPDATED_EVENT_TYPE,
    exports.GOOGLE_LSA_SYNC_COMPLETED_EVENT_TYPE,
    exports.GOOGLE_LSA_SYNC_FAILED_EVENT_TYPE,
];
exports.VOICE_INTEGRATION_EVENT_TYPES = [
    exports.VOICE_VOICEMAIL_RECORDING_READY_EVENT_TYPE,
    exports.VOICE_TRACKING_NUMBER_UPDATED_EVENT_TYPE,
];
exports.SERVICE_PLAN_INTEGRATION_EVENT_TYPES = [
    exports.SERVICE_PLAN_TEMPLATE_CREATED_EVENT_TYPE,
    exports.SERVICE_PLAN_TEMPLATE_STATUS_CHANGED_EVENT_TYPE,
    exports.SERVICE_PLAN_ENROLLMENT_CREATED_EVENT_TYPE,
    exports.SERVICE_PLAN_ENROLLMENT_STATUS_CHANGED_EVENT_TYPE,
    exports.SERVICE_PLAN_OCCURRENCE_DUE_EVENT_TYPE,
    exports.SERVICE_PLAN_OCCURRENCE_GENERATED_EVENT_TYPE,
];
exports.COMPENSATION_INTEGRATION_EVENT_TYPES = [
    exports.COMPENSATION_CALCULATION_APPROVED_EVENT_TYPE,
    exports.COMPENSATION_ADJUSTMENT_ADDED_EVENT_TYPE,
];
exports.CORE_OPERATIONAL_INTEGRATION_EVENT_TYPES = [
    ...exports.BUSINESS_INTEGRATION_EVENT_TYPES,
    ...exports.ORGANIZATION_INTEGRATION_EVENT_TYPES,
    ...exports.CATALOG_INTEGRATION_EVENT_TYPES,
    ...exports.CUSTOMER_INTEGRATION_EVENT_TYPES,
    ...exports.TEAM_LIFECYCLE_INTEGRATION_EVENT_TYPES,
    ...exports.SERVICE_PLAN_INTEGRATION_EVENT_TYPES,
    ...exports.PENDING_JOB_PIPELINE_INTEGRATION_EVENT_TYPES,
    exports.JOB_LINE_ITEMS_CHANGED_EVENT_TYPE,
    exports.JOB_ATTACHMENT_ADDED_EVENT_TYPE,
    exports.JOB_ATTACHMENT_REMOVED_EVENT_TYPE,
    exports.MESSAGE_SEND_REQUESTED_EVENT_TYPE,
];
exports.BUILT_IN_INTEGRATION_EVENT_TYPES = [
    ...exports.ORGANIZATION_INTEGRATION_EVENT_TYPES,
    ...exports.CATALOG_INTEGRATION_EVENT_TYPES,
    ...exports.CUSTOMER_INTEGRATION_EVENT_TYPES,
    ...exports.ONLINE_BOOKING_INTEGRATION_EVENT_TYPES,
    ...exports.LEAD_INTEGRATION_EVENT_TYPES,
    ...exports.JOB_INBOX_INTEGRATION_EVENT_TYPES,
    ...exports.CONVERSATION_INTEGRATION_EVENT_TYPES,
    ...exports.COMMUNICATION_INTEGRATION_EVENT_TYPES,
    ...exports.GOOGLE_LSA_INTEGRATION_EVENT_TYPES,
    ...exports.VOICE_INTEGRATION_EVENT_TYPES,
    ...exports.SCHEDULE_INTEGRATION_EVENT_TYPES,
    ...exports.PENDING_JOB_PIPELINE_INTEGRATION_EVENT_TYPES,
    "estimate.created.v1",
    "estimate.updated.v1",
    "estimate.accepted.v1",
    "estimate.declined.v1",
    "estimate.version_created.v1",
    "estimate.delivery_queued.v1",
    "estimate.sent.v1",
    "estimate.delivery_failed.v1",
    "estimate.converted.v1",
    "estimate.delivered.v1",
    "estimate.viewed.v1",
    "portal.invitation_queued.v1",
    "portal.magic_link_requested.v1",
    "portal.invitation_sent.v1",
    "portal.invitation_failed.v1",
    "portal.access_revoked.v1",
    "portal.magic_link_exchanged.v1",
    "invoice.created.v1",
    "invoice.updated.v1",
    "invoice.issued.v1",
    "invoice.voided.v1",
    exports.INVOICE_PAID_EVENT_TYPE,
    exports.INVOICE_VIEWED_EVENT_TYPE,
    ...exports.INVOICE_DELIVERY_INTEGRATION_EVENT_TYPES,
    exports.PAYMENT_RECORDED_EVENT_TYPE,
    exports.PAYMENT_REVERSED_EVENT_TYPE,
    exports.PAYMENT_FAILED_EVENT_TYPE,
    exports.PAYMENT_REFUND_FAILED_EVENT_TYPE,
    exports.PAYMENT_RECONCILIATION_REQUIRED_EVENT_TYPE,
    exports.PAYMENT_DISPUTE_UPDATED_EVENT_TYPE,
    exports.PAYMENT_DISPUTE_ACTION_REQUIRED_EVENT_TYPE,
    ...exports.COMPENSATION_INTEGRATION_EVENT_TYPES,
    exports.PREPAYMENT_CREATED_EVENT_TYPE,
    exports.PREPAYMENT_COLLECTED_EVENT_TYPE,
    exports.PREPAYMENT_COLLECTION_REVERSED_EVENT_TYPE,
    exports.PREPAYMENT_APPLIED_EVENT_TYPE,
    exports.PREPAYMENT_CANCELED_EVENT_TYPE,
    ...exports.TEAM_INTEGRATION_EVENT_TYPES,
    ...exports.JOB_APPOINTMENT_INTEGRATION_EVENT_TYPES,
];
exports.CORE_INTEGRATION_EVENT_TYPES = uniqueEventTypes([
    ...exports.CORE_OPERATIONAL_INTEGRATION_EVENT_TYPES,
    ...exports.BUILT_IN_INTEGRATION_EVENT_TYPES,
]);
function uniqueEventTypes(values) {
    return [...new Set(values)];
}
exports.builtInIntegrationEventTypeSchema = zod_1.z.enum(exports.BUILT_IN_INTEGRATION_EVENT_TYPES);
exports.coreIntegrationEventTypeSchema = zod_1.z.enum(exports.CORE_INTEGRATION_EVENT_TYPES);
const businessScopedDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
})
    .passthrough();
const jobInboxItemEventDataSchema = businessScopedDataSchema.extend({
    itemId: zod_1.z.string().uuid(),
    source: zod_1.z.enum([
        "ONLINE_BOOKING",
        "LEAD_FORM",
        "WEBSITE_CHAT",
        "GOOGLE_BUSINESS_PROFILE",
        "GOOGLE_LOCAL_SERVICES",
        "ANGI",
        "THUMBTACK",
        "ELOCAL",
        "API",
        "APP",
        "OTHER",
    ]),
    externalSourceId: zod_1.z.string().min(1).max(255),
});
const estimateEventDataSchema = businessScopedDataSchema.extend({
    estimateId: zod_1.z.string().uuid(),
});
const businessCreatedEventDataSchema = businessScopedDataSchema.extend({
    defaultLocationId: zod_1.z.string().uuid(),
    ownerUserId: zod_1.z.string().uuid(),
});
const businessUpdatedEventDataSchema = businessScopedDataSchema.extend({
    changedFields: zod_1.z
        .array(zod_1.z.enum([
        "displayName",
        "legalName",
        "contactEmail",
        "phone",
        "logoUrl",
        "websiteUrl",
        "currency",
        "defaultTimezone",
    ]))
        .min(1),
});
const businessLocationEventDataSchema = businessScopedDataSchema.extend({
    locationId: zod_1.z.string().uuid(),
});
exports.organizationLocationAccessUpdatedEventDataSchema = zod_1.z
    .object({
    organizationId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    tenantAccessGrantId: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid(),
    mode: zod_1.z.enum(["ALL", "SELECTED"]),
    locationIds: zod_1.z.array(zod_1.z.string().uuid()).max(250),
    actorOrganizationMembershipId: zod_1.z.string().uuid(),
})
    .strict();
exports.onlineBookingServiceAreaUpdatedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    operationalLocationId: zod_1.z.string().uuid(),
    enforcementEnabled: zod_1.z.boolean(),
    activeZipCount: zod_1.z.number().int().nonnegative(),
    changedFields: zod_1.z
        .array(zod_1.z.enum(["enforcementEnabled", "outOfAreaMessage", "zipEntries"]))
        .min(1)
        .max(3),
    actorMembershipId: zod_1.z.string().uuid().nullable(),
})
    .strict();
exports.onlineBookingConfigurationPublishedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    configurationVersionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    schemaVersion: zod_1.z.literal(1),
    operationalLocationId: zod_1.z.string().uuid(),
    serviceIds: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(100),
    actorMembershipId: zod_1.z.string().uuid(),
})
    .strict();
exports.onlineBookingSettingsUpdatedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    operationalLocationId: zod_1.z.string().uuid(),
    actorMembershipId: zod_1.z.string().uuid(),
})
    .strict();
exports.googleBookingPublicationSyncRequestedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    operationalLocationId: zod_1.z.string().uuid(),
    requestId: zod_1.z.string().uuid(),
    trigger: zod_1.z.enum(["MANUAL", "SCHEDULED"]),
    requestedByMembershipId: zod_1.z.string().uuid().nullable(),
})
    .strict();
exports.onlineBookingEmbedConfigurationUpdatedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    allowedOriginCount: zod_1.z.number().int().min(0).max(25),
    completionRedirectConfigured: zod_1.z.boolean(),
    cancellationRedirectConfigured: zod_1.z.boolean(),
    actorMembershipId: zod_1.z.string().uuid(),
})
    .strict();
const estimateDeliveryEventDataSchema = estimateEventDataSchema.extend({
    deliveryId: zod_1.z.string().uuid(),
});
const invoiceEventDataSchema = businessScopedDataSchema.extend({
    invoiceId: zod_1.z.string().uuid(),
});
const invoiceDeliveryEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    deliveryId: zod_1.z.string().uuid(),
})
    .strict();
const paymentEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    paymentId: zod_1.z.string().uuid(),
    amountCents: zod_1.z.number().int().positive().optional(),
    method: zod_1.z
        .enum([
        "CASH",
        "CHECK",
        "CARD",
        "CARD_EXTERNAL",
        "BANK_TRANSFER",
        "OTHER",
    ])
        .optional(),
})
    .strict();
const paymentDisputeEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    disputeId: zod_1.z.string().uuid(),
    checkoutSessionId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    customerId: zod_1.z.string().uuid(),
    amountCents: zod_1.z.number().int().positive(),
    currency: zod_1.z.string().length(3),
    status: zod_1.z.enum(["NEEDS_RESPONSE", "UNDER_REVIEW", "WON", "LOST", "CLOSED"]),
    responseDueAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
    submissionStatus: zod_1.z.enum([
        "NOT_STARTED",
        "READY",
        "SUBMITTING",
        "SUBMITTED",
        "FAILED",
    ]),
})
    .strict();
exports.compensationEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    operationalLocationId: zod_1.z.string().uuid(),
    calculationId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid().nullable(),
    amountCents: zod_1.z.number().int(),
    actorMembershipId: zod_1.z.string().uuid(),
})
    .strict();
const prepaymentEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    prepaymentId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    customerId: zod_1.z.string().uuid(),
})
    .strict();
const appointmentStatusSchema = zod_1.z.enum([
    "SCHEDULED",
    "EN_ROUTE",
    "IN_PROGRESS",
    "COMPLETED",
    "CANCELED",
]);
const jobStatusSchema = zod_1.z.enum([
    "NEW",
    "SCHEDULED",
    "IN_PROGRESS",
    "COMPLETED",
    "CANCELED",
]);
const activityActorDataShape = {
    actorType: zod_1.z.enum(["STAFF", "CUSTOMER", "APP", "SYSTEM"]).optional(),
    actorMembershipId: zod_1.z.string().uuid().nullable().optional(),
    actorInstallationId: zod_1.z.string().uuid().nullable().optional(),
    actorName: zod_1.z.string().trim().min(1).max(160).nullable().optional(),
};
const servicePlanActorDataShape = {
    actorType: zod_1.z.enum(["STAFF", "SYSTEM"]),
    actorMembershipId: zod_1.z.string().uuid().nullable(),
    actorName: zod_1.z.string().trim().min(1).max(160).nullable(),
};
const servicePlanTemplateEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    ...servicePlanActorDataShape,
    templateId: zod_1.z.string().uuid(),
})
    .strict();
const servicePlanEnrollmentEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    ...servicePlanActorDataShape,
    templateId: zod_1.z.string().uuid(),
    enrollmentId: zod_1.z.string().uuid(),
    customerId: zod_1.z.string().uuid(),
    serviceLocationId: zod_1.z.string().uuid(),
})
    .strict();
const servicePlanOccurrenceEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    enrollmentId: zod_1.z.string().uuid(),
    occurrenceId: zod_1.z.string().uuid(),
    scheduledStartAt: zod_1.z.string().datetime({ offset: true }),
    scheduledEndAt: zod_1.z.string().datetime({ offset: true }),
})
    .strict();
const leadSourceSchema = zod_1.z.enum([
    "MANUAL",
    "PHONE",
    "SMS",
    "WEBSITE",
    "ONLINE_BOOKING",
    "REFERRAL",
    "MARKETPLACE",
    "API",
    "APP",
    "OTHER",
]);
const leadStatusSchema = zod_1.z.enum([
    "NEW",
    "OPEN",
    "CONTACTED",
    "QUALIFIED",
    "WON",
    "LOST",
    "ARCHIVED",
]);
const leadEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    ...activityActorDataShape,
    leadId: zod_1.z.string().uuid(),
    source: leadSourceSchema,
})
    .strict();
const pendingJobPipelineStageSchema = zod_1.z.enum([
    "NEW_REQUEST",
    "ESTIMATE_NEEDED",
    "AWAITING_CUSTOMER",
    "APPROVED_UNSCHEDULED",
    "ON_HOLD",
    "READY_TO_SCHEDULE",
]);
exports.pendingJobPipelineEventDataSchema = businessScopedDataSchema
    .extend({
    businessLocationId: zod_1.z.string().uuid(),
    pipelineItemId: zod_1.z.string().uuid(),
    sourceType: zod_1.z.enum(["LEAD", "ESTIMATE", "JOB"]),
    sourceId: zod_1.z.string().uuid(),
    ownerMembershipId: zod_1.z.string().uuid().nullable(),
})
    .strict();
const conversationChannelSchema = zod_1.z.enum([
    "EMAIL",
    "SMS",
    "WEB_CHAT",
    "TEAM",
    "MESSAGING",
]);
const conversationStatusSchema = zod_1.z.enum(["OPEN", "PENDING", "CLOSED", "SPAM"]);
const conversationEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    ...activityActorDataShape,
    conversationId: zod_1.z.string().uuid(),
})
    .strict();
const messageEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    conversationId: zod_1.z.string().uuid(),
    messageId: zod_1.z.string().uuid(),
    channel: conversationChannelSchema,
})
    .strict();
const communicationMessageEventDataSchema = messageEventDataSchema.extend({
    provider: zod_1.z.string().min(1).max(80).nullable(),
    providerMessageId: zod_1.z.string().min(1).max(255).nullable(),
});
const googleLsaConnectionModeSchema = zod_1.z.enum(["SANDBOX", "LIVE"]);
const googleLsaConnectionStatusSchema = zod_1.z.enum([
    "NOT_CONNECTED",
    "AUTHORIZING",
    "CONNECTED",
    "DISABLED",
    "NEEDS_ATTENTION",
]);
const googleLsaActivationBlockerCodeSchema = zod_1.z.enum([
    "LIVE_PROVIDER_ACCESS_NOT_APPROVED",
    "DEVELOPER_TOKEN_NOT_CONFIGURED",
    "OAUTH_CLIENT_NOT_CONFIGURED",
    "OAUTH_AUTHORIZATION_REQUIRED",
    "REQUIRED_SCOPE_NOT_GRANTED",
    "GOOGLE_ADS_CUSTOMER_ID_REQUIRED",
    "EXTERNAL_ACCOUNT_NOT_SELECTED",
    "REFRESH_TOKEN_NOT_AVAILABLE",
    "CONNECTION_DISABLED",
]);
const googleLsaSafeErrorCodeSchema = zod_1.z.enum([
    "GOOGLE_LSA_NOT_CONFIGURED",
    "GOOGLE_LSA_CONNECTION_NOT_FOUND",
    "GOOGLE_LSA_CONNECTION_DISABLED",
    "GOOGLE_LSA_LIVE_ACTIVATION_REQUIRED",
    "GOOGLE_LSA_OAUTH_STATE_INVALID",
    "GOOGLE_LSA_OAUTH_EXCHANGE_FAILED",
    "GOOGLE_LSA_OAUTH_SCOPE_MISSING",
    "GOOGLE_LSA_TOKEN_REFRESH_FAILED",
    "GOOGLE_LSA_PROVIDER_UNAVAILABLE",
    "GOOGLE_LSA_RATE_LIMITED",
    "GOOGLE_LSA_SYNC_FAILED",
    "GOOGLE_LSA_EVENT_INVALID",
    "GOOGLE_LSA_EVENT_REPLAYED",
    "GOOGLE_LSA_THREAD_NOT_FOUND",
    "GOOGLE_LSA_REPLY_NOT_SUPPORTED",
    "GOOGLE_LSA_REPLY_REJECTED",
]);
const googleLsaSyncTriggerSchema = zod_1.z.enum(["MANUAL", "SCHEDULED", "SANDBOX"]);
const googleLsaEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    connectionId: zod_1.z.string().uuid(),
})
    .strict();
exports.googleLsaConnectionUpdatedEventDataSchema = googleLsaEventDataSchema.extend({
    mode: googleLsaConnectionModeSchema,
    previousStatus: googleLsaConnectionStatusSchema.nullable(),
    status: googleLsaConnectionStatusSchema,
    enabled: zod_1.z.boolean(),
    liveActivationReady: zod_1.z.boolean(),
    activationBlockerCodes: zod_1.z.array(googleLsaActivationBlockerCodeSchema),
    actorMembershipId: zod_1.z.string().uuid().nullable(),
});
exports.googleLsaSyncCompletedEventDataSchema = googleLsaEventDataSchema.extend({
    syncRunId: zod_1.z.string().uuid(),
    trigger: googleLsaSyncTriggerSchema,
    threadsSeen: zod_1.z.number().int().nonnegative(),
    messagesSeen: zod_1.z.number().int().nonnegative(),
    duplicateEvents: zod_1.z.number().int().nonnegative(),
    repliesReconciled: zod_1.z.number().int().nonnegative(),
});
exports.googleLsaSyncFailedEventDataSchema = googleLsaEventDataSchema.extend({
    syncRunId: zod_1.z.string().uuid(),
    trigger: googleLsaSyncTriggerSchema,
    safeErrorCode: googleLsaSafeErrorCodeSchema,
    retryable: zod_1.z.boolean(),
});
const voiceVoicemailRecordingReadyEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    callId: zod_1.z.string().uuid(),
    recordingId: zod_1.z.string().uuid(),
    voicemailId: zod_1.z.string().uuid(),
    durationSeconds: zod_1.z.number().int().nonnegative().nullable(),
})
    .strict();
exports.voiceTrackingNumberUpdatedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    trackingNumberId: zod_1.z.string().uuid(),
    operationalLocationId: zod_1.z.string().uuid().nullable(),
    onboardingStatus: zod_1.z.enum([
        "DRAFT",
        "REQUESTED",
        "IN_REVIEW",
        "ACTION_REQUIRED",
        "ACTIVE",
        "FAILED",
        "CANCELED",
    ]),
    ownershipStatus: zod_1.z.enum(["UNVERIFIED", "PROVIDER_CONFIRMED"]),
    changeType: zod_1.z.enum([
        "DISCOVERED",
        "PROVISIONING_REQUESTED",
        "PORT_REQUESTED",
        "ASSIGNMENT_UPDATED",
        "ACTIVATED",
    ]),
})
    .strict();
const jobCreatedEventDataSchema = businessScopedDataSchema.extend({
    ...activityActorDataShape,
    businessLocationId: zod_1.z.string().uuid().optional(),
    customerId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    serviceLocationId: zod_1.z.string().uuid(),
    sourceEstimateId: zod_1.z.string().uuid().nullable(),
    totalCents: zod_1.z.number().int().nonnegative(),
});
const jobCreatedFromEstimateEventDataSchema = businessScopedDataSchema.extend({
    ...activityActorDataShape,
    estimateId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
});
const jobUpdatedEventDataSchema = businessScopedDataSchema.extend({
    ...activityActorDataShape,
    changedFields: zod_1.z
        .array(zod_1.z.enum(["summary", "description", "priority", "checklists"]))
        .min(1),
    jobId: zod_1.z.string().uuid(),
});
const jobStatusChangedEventDataSchema = businessScopedDataSchema.extend({
    ...activityActorDataShape,
    fromStatus: jobStatusSchema,
    jobId: zod_1.z.string().uuid(),
    toStatus: jobStatusSchema,
});
const jobLineItemsChangedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    ...activityActorDataShape,
    jobId: zod_1.z.string().uuid(),
    changeType: zod_1.z.enum(["ADDED", "UPDATED", "REMOVED", "REORDERED"]),
    lineItemId: zod_1.z.string().uuid().nullable(),
    lineItemCount: zod_1.z.number().int().nonnegative().max(100),
    subtotalCents: zod_1.z.number().int().nonnegative(),
    taxableSubtotalCents: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    totalCents: zod_1.z.number().int().nonnegative(),
})
    .strict();
const jobAttachmentEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    ...activityActorDataShape,
    jobId: zod_1.z.string().uuid(),
    attachmentId: zod_1.z.string().uuid(),
    kind: zod_1.z.enum(["FILE", "PHOTO"]),
    originalFileName: zod_1.z.string().min(1).max(255),
    mimeType: zod_1.z.string().min(3).max(120),
    fileSizeBytes: zod_1.z.number().int().positive(),
    uploadedByMembershipId: zod_1.z.string().uuid(),
})
    .strict();
const appointmentCreatedEventDataSchema = businessScopedDataSchema.extend({
    ...activityActorDataShape,
    appointmentId: zod_1.z.string().uuid(),
    assignedMembershipId: zod_1.z.string().uuid().nullable().optional(),
    jobId: zod_1.z.string().uuid(),
});
const appointmentAssignedEventDataSchema = appointmentCreatedEventDataSchema.extend({
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
    fromAssignedMembershipId: zod_1.z.string().uuid().nullable(),
});
const appointmentStatusChangedEventDataSchema = appointmentCreatedEventDataSchema.extend({
    assignedMembershipId: zod_1.z.string().uuid().nullable().optional(),
    fromStatus: appointmentStatusSchema,
    toStatus: appointmentStatusSchema,
});
const appointmentRescheduledEventDataSchema = appointmentCreatedEventDataSchema.extend({
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
    endAt: zod_1.z.string().datetime({ offset: true }),
    fromAssignedMembershipId: zod_1.z.string().uuid().nullable(),
    fromEndAt: zod_1.z.string().datetime({ offset: true }),
    fromStartAt: zod_1.z.string().datetime({ offset: true }),
    startAt: zod_1.z.string().datetime({ offset: true }),
});
const scheduleEventCreatedEventDataSchema = businessScopedDataSchema.extend({
    ...activityActorDataShape,
    businessLocationId: zod_1.z.string().uuid(),
    scheduleEventId: zod_1.z.string().uuid(),
    title: zod_1.z.string().trim().min(2).max(160),
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
    startAt: zod_1.z.string().datetime({ offset: true }),
    endAt: zod_1.z.string().datetime({ offset: true }),
});
const portalEventDataSchema = businessScopedDataSchema.extend({
    customerId: zod_1.z.string().uuid(),
    contactId: zod_1.z.string().uuid(),
});
const portalMagicLinkEventDataSchema = portalEventDataSchema.extend({
    magicLinkId: zod_1.z.string().uuid(),
});
const catalogItemEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    catalogItemId: zod_1.z.string().uuid(),
})
    .strict();
const catalogItemChangedEventDataSchema = catalogItemEventDataSchema.extend({
    categoryId: zod_1.z.string().uuid().nullable(),
});
const priceBookVersionEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    organizationId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    locationId: zod_1.z.string().uuid().nullable(),
    priceBookVersionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    scopeType: zod_1.z.enum(["ORGANIZATION_DEFAULT", "LOCATION_OVERRIDE"]),
    effectiveAt: zod_1.z.string().datetime(),
})
    .strict()
    .superRefine((value, context) => {
    if (value.scopeType === "ORGANIZATION_DEFAULT" && value.locationId) {
        context.addIssue({
            code: "custom",
            path: ["locationId"],
            message: "Organization-default events cannot target one location.",
        });
    }
    if (value.scopeType === "LOCATION_OVERRIDE" && !value.locationId) {
        context.addIssue({
            code: "custom",
            path: ["locationId"],
            message: "Location-override events require a location.",
        });
    }
});
const customerEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    customerId: zod_1.z.string().uuid(),
})
    .strict();
const customerContactRoleSchema = zod_1.z.enum([
    "PRIMARY",
    "ESTIMATE_APPROVER",
    "BILLING",
    "ON_SITE",
]);
const customerContactEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    contactId: zod_1.z.string().uuid(),
    customerId: zod_1.z.string().uuid(),
})
    .strict();
const teamRoleSchema = zod_1.z.enum(["OWNER", "ADMIN", "DISPATCHER", "TECHNICIAN"]);
const staffCapabilitySchema = zod_1.z.enum([
    "assigned_jobs:read",
    "job_status:update",
    "time_tracking:read_self",
    "time_tracking:write",
    "job_notes:write",
    "job_photos:write",
    "job_checklists:write",
    "assigned_customer_contacts:read",
    "prices:read",
    "job_line_items:write",
    "estimates:create",
    "payments:collect",
    "schedule:read_all",
    "customers:read_all",
    "leads:read_all",
    "communications:read",
    "chats:read",
    "chats:manage",
    "job_inbox:read",
    "job_inbox:manage",
    "job_inbox:assign",
    "job_inbox:convert",
    "job_inbox:dismiss",
    "inbox_settings:manage",
    "lead_channels:read",
    "lead_channels:manage",
    "lead_sources:read",
    "lead_sources:manage",
    "api_leads:manage",
    "service_areas:read",
    "service_areas:manage",
    "estimates:read_all",
    "invoices:read_all",
    "payment_disputes:read",
    "payment_disputes:manage",
    "compensation:read",
    "compensation:manage",
    "compensation:approve",
    "compensation:read_self",
    "voice:use",
]);
const teamMembershipEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid(),
})
    .strict();
const teamWorkingHoursSchema = zod_1.z
    .array(zod_1.z
    .object({
    weekday: zod_1.z.enum([
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
        "SUNDAY",
    ]),
    isWorking: zod_1.z.boolean(),
    startMinute: zod_1.z.number().int().min(0).max(1439).nullable(),
    endMinute: zod_1.z.number().int().min(1).max(1440).nullable(),
})
    .strict()
    .superRefine((value, context) => {
    if (!value.isWorking) {
        if (value.startMinute !== null || value.endMinute !== null) {
            context.addIssue({
                code: "custom",
                message: "Non-working days cannot have working hours.",
            });
        }
        return;
    }
    if (value.startMinute === null ||
        value.endMinute === null ||
        value.startMinute >= value.endMinute) {
        context.addIssue({
            code: "custom",
            message: "Working days require a valid start and end time.",
        });
    }
}))
    .length(7)
    .superRefine((days, context) => {
    if (new Set(days.map((day) => day.weekday)).size !== 7) {
        context.addIssue({
            code: "custom",
            message: "Working hours must include each weekday once.",
        });
    }
});
const teamMemberInvitedEventDataSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    invitationId: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid(),
    role: teamRoleSchema.exclude(["OWNER"]),
})
    .strict();
const builtInEventDataSchemas = {
    [exports.GOOGLE_LSA_CONNECTION_UPDATED_EVENT_TYPE]: exports.googleLsaConnectionUpdatedEventDataSchema,
    [exports.GOOGLE_LSA_SYNC_COMPLETED_EVENT_TYPE]: exports.googleLsaSyncCompletedEventDataSchema,
    [exports.GOOGLE_LSA_SYNC_FAILED_EVENT_TYPE]: exports.googleLsaSyncFailedEventDataSchema,
    [exports.ONLINE_BOOKING_SERVICE_AREA_UPDATED_EVENT_TYPE]: exports.onlineBookingServiceAreaUpdatedEventDataSchema,
    [exports.ONLINE_BOOKING_CONFIGURATION_PUBLISHED_EVENT_TYPE]: exports.onlineBookingConfigurationPublishedEventDataSchema,
    [exports.ONLINE_BOOKING_SETTINGS_UPDATED_EVENT_TYPE]: exports.onlineBookingSettingsUpdatedEventDataSchema,
    [exports.ONLINE_BOOKING_EMBED_CONFIGURATION_UPDATED_EVENT_TYPE]: exports.onlineBookingEmbedConfigurationUpdatedEventDataSchema,
    [exports.GOOGLE_BOOKING_PUBLICATION_SYNC_REQUESTED_EVENT_TYPE]: exports.googleBookingPublicationSyncRequestedEventDataSchema,
    [exports.SERVICE_PLAN_TEMPLATE_CREATED_EVENT_TYPE]: servicePlanTemplateEventDataSchema,
    [exports.SERVICE_PLAN_TEMPLATE_STATUS_CHANGED_EVENT_TYPE]: servicePlanTemplateEventDataSchema.extend({
        fromStatus: zod_1.z.enum(["ACTIVE", "ARCHIVED"]),
        toStatus: zod_1.z.enum(["ACTIVE", "ARCHIVED"]),
    }),
    [exports.SERVICE_PLAN_ENROLLMENT_CREATED_EVENT_TYPE]: servicePlanEnrollmentEventDataSchema.extend({
        occurrenceId: zod_1.z.string().uuid(),
        nextServiceAt: zod_1.z.string().datetime({ offset: true }),
    }),
    [exports.SERVICE_PLAN_ENROLLMENT_STATUS_CHANGED_EVENT_TYPE]: servicePlanEnrollmentEventDataSchema.extend({
        fromStatus: zod_1.z.enum(["ACTIVE", "PAUSED", "CANCELED"]),
        toStatus: zod_1.z.enum(["ACTIVE", "PAUSED", "CANCELED"]),
    }),
    [exports.SERVICE_PLAN_OCCURRENCE_DUE_EVENT_TYPE]: servicePlanOccurrenceEventDataSchema,
    [exports.SERVICE_PLAN_OCCURRENCE_GENERATED_EVENT_TYPE]: servicePlanOccurrenceEventDataSchema.extend({
        jobId: zod_1.z.string().uuid(),
        appointmentId: zod_1.z.string().uuid(),
    }),
    [exports.VOICE_VOICEMAIL_RECORDING_READY_EVENT_TYPE]: voiceVoicemailRecordingReadyEventDataSchema,
    [exports.VOICE_TRACKING_NUMBER_UPDATED_EVENT_TYPE]: exports.voiceTrackingNumberUpdatedEventDataSchema,
    [exports.LEAD_CREATED_EVENT_TYPE]: leadEventDataSchema.extend({
        sourceReference: zod_1.z.string().min(1).max(255).nullable(),
        status: leadStatusSchema,
        assignedToUserId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.LEAD_UPDATED_EVENT_TYPE]: leadEventDataSchema.extend({
        changedFields: zod_1.z
            .array(zod_1.z.enum([
            "firstName",
            "lastName",
            "companyName",
            "phone",
            "email",
            "serviceAddress",
            "serviceCategoryId",
            "summary",
            "description",
            "preferredWindow",
            "estimatedValue",
            "metadata",
        ]))
            .min(1),
    }),
    [exports.LEAD_STATUS_CHANGED_EVENT_TYPE]: leadEventDataSchema.extend({
        fromStatus: leadStatusSchema,
        toStatus: leadStatusSchema.exclude(["WON", "ARCHIVED"]),
    }),
    [exports.LEAD_ASSIGNED_EVENT_TYPE]: leadEventDataSchema.extend({
        fromAssignedToUserId: zod_1.z.string().uuid().nullable(),
        assignedToUserId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.LEAD_CONVERTED_EVENT_TYPE]: leadEventDataSchema.extend({
        customerId: zod_1.z.string().uuid(),
        serviceLocationId: zod_1.z.string().uuid(),
        conversionTarget: zod_1.z.enum(["ESTIMATE", "JOB"]),
        estimateId: zod_1.z.string().uuid().nullable(),
        jobId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.LEAD_ARCHIVED_EVENT_TYPE]: leadEventDataSchema.extend({
        fromStatus: leadStatusSchema.exclude(["ARCHIVED"]),
    }),
    [exports.PENDING_JOB_PIPELINE_ITEM_CREATED_EVENT_TYPE]: exports.pendingJobPipelineEventDataSchema.extend({
        stage: pendingJobPipelineStageSchema,
    }),
    [exports.PENDING_JOB_PIPELINE_ITEM_UPDATED_EVENT_TYPE]: exports.pendingJobPipelineEventDataSchema.extend({
        changedFields: zod_1.z
            .array(zod_1.z.enum(["ownerMembershipId", "priority", "followUpAt", "note"]))
            .min(1),
        reminderVersion: zod_1.z.number().int().nonnegative(),
    }),
    [exports.PENDING_JOB_PIPELINE_STAGE_CHANGED_EVENT_TYPE]: exports.pendingJobPipelineEventDataSchema.extend({
        fromStage: pendingJobPipelineStageSchema,
        toStage: pendingJobPipelineStageSchema,
        reasonCode: zod_1.z.string().min(1).max(80).nullable(),
    }),
    [exports.PENDING_JOB_PIPELINE_REMINDER_DUE_EVENT_TYPE]: exports.pendingJobPipelineEventDataSchema.extend({
        stage: pendingJobPipelineStageSchema,
        reminderVersion: zod_1.z.number().int().positive(),
        followUpAt: zod_1.z.string().datetime({ offset: true }),
    }),
    [exports.PENDING_JOB_PIPELINE_SCHEDULED_EVENT_TYPE]: exports.pendingJobPipelineEventDataSchema.extend({
        appointmentId: zod_1.z.string().uuid(),
        jobId: zod_1.z.string().uuid(),
        scheduledStartAt: zod_1.z.string().datetime({ offset: true }),
        scheduledEndAt: zod_1.z.string().datetime({ offset: true }),
        assignedMembershipId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.JOB_INBOX_ITEM_RECEIVED_EVENT_TYPE]: jobInboxItemEventDataSchema.extend({
        status: zod_1.z.literal("NEW"),
        leadId: zod_1.z.string().uuid().nullable(),
        jobId: zod_1.z.string().uuid().nullable(),
        bookingRequestId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.JOB_INBOX_ITEM_ASSIGNED_EVENT_TYPE]: jobInboxItemEventDataSchema.extend({
        fromAssignedToMembershipId: zod_1.z.string().uuid().nullable(),
        assignedToMembershipId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.JOB_INBOX_ITEM_STATUS_CHANGED_EVENT_TYPE]: jobInboxItemEventDataSchema.extend({
        fromStatus: zod_1.z.enum(["NEW", "IN_REVIEW", "ACCEPTED", "DISMISSED", "SPAM"]),
        toStatus: zod_1.z.enum(["IN_REVIEW", "ACCEPTED", "DISMISSED", "SPAM"]),
    }),
    [exports.JOB_INBOX_ITEM_CONVERTED_EVENT_TYPE]: jobInboxItemEventDataSchema.extend({
        conversionTarget: zod_1.z.enum(["LEAD", "JOB"]),
        entityId: zod_1.z.string().uuid(),
        idempotencyKey: zod_1.z.string().uuid(),
    }),
    [exports.CONVERSATION_CREATED_EVENT_TYPE]: conversationEventDataSchema.extend({
        channel: conversationChannelSchema,
        status: conversationStatusSchema,
        contactName: zod_1.z.string().min(1).max(160).nullable(),
        assignedToMembershipId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.CONVERSATION_ASSIGNED_EVENT_TYPE]: conversationEventDataSchema.extend({
        fromAssignedToMembershipId: zod_1.z.string().uuid().nullable(),
        assignedToMembershipId: zod_1.z.string().uuid().nullable(),
    }),
    [exports.CONVERSATION_STATUS_CHANGED_EVENT_TYPE]: conversationEventDataSchema.extend({
        fromStatus: conversationStatusSchema,
        toStatus: conversationStatusSchema,
    }),
    [exports.CONVERSATION_LINKED_EVENT_TYPE]: conversationEventDataSchema.extend({
        entityType: zod_1.z.enum([
            "LEAD",
            "CUSTOMER",
            "SERVICE_LOCATION",
            "JOB",
            "ESTIMATE",
            "INVOICE",
        ]),
        entityId: zod_1.z.string().uuid(),
    }),
    [exports.MESSAGE_SEND_REQUESTED_EVENT_TYPE]: messageEventDataSchema,
    [exports.MESSAGE_RECEIVED_EVENT_TYPE]: messageEventDataSchema.extend({
        sender: zod_1.z.string().min(1).max(320),
        recipient: zod_1.z.string().min(1).max(320),
        assignedToMembershipId: zod_1.z.string().uuid().nullable(),
        actorMembershipId: zod_1.z.string().uuid().nullable().optional(),
    }),
    [exports.MESSAGE_SENT_EVENT_TYPE]: messageEventDataSchema.extend({
        provider: zod_1.z.string().min(1).max(80),
        providerMessageId: zod_1.z.string().min(1).max(255).nullable(),
    }),
    [exports.MESSAGE_DELIVERED_EVENT_TYPE]: messageEventDataSchema.extend({
        provider: zod_1.z.string().min(1).max(80),
        providerMessageId: zod_1.z.string().min(1).max(255),
    }),
    [exports.MESSAGE_DELIVERY_FAILED_EVENT_TYPE]: messageEventDataSchema.extend({
        reasonCode: zod_1.z.string().min(1).max(120),
    }),
    [exports.COMMUNICATION_MESSAGE_RECEIVED_EVENT_TYPE]: communicationMessageEventDataSchema.extend({
        direction: zod_1.z.literal("INBOUND"),
        sender: zod_1.z.string().min(1).max(320),
        recipient: zod_1.z.string().min(1).max(320),
    }),
    [exports.COMMUNICATION_MESSAGE_QUEUED_EVENT_TYPE]: communicationMessageEventDataSchema.extend({
        direction: zod_1.z.literal("OUTBOUND"),
        recipient: zod_1.z.string().min(1).max(320),
    }),
    [exports.COMMUNICATION_MESSAGE_SENT_EVENT_TYPE]: communicationMessageEventDataSchema.extend({
        direction: zod_1.z.literal("OUTBOUND"),
        provider: zod_1.z.string().min(1).max(80),
        providerMessageId: zod_1.z.string().min(1).max(255),
    }),
    [exports.COMMUNICATION_MESSAGE_DELIVERED_EVENT_TYPE]: communicationMessageEventDataSchema.extend({
        direction: zod_1.z.literal("OUTBOUND"),
        provider: zod_1.z.string().min(1).max(80),
        providerMessageId: zod_1.z.string().min(1).max(255),
    }),
    [exports.COMMUNICATION_MESSAGE_FAILED_EVENT_TYPE]: communicationMessageEventDataSchema.extend({
        direction: zod_1.z.literal("OUTBOUND"),
        reasonCode: zod_1.z.string().min(1).max(120),
    }),
    [exports.COMMUNICATION_CONVERSATION_UPDATED_EVENT_TYPE]: conversationEventDataSchema.extend({
        change: zod_1.z.enum([
            "MESSAGE_RECEIVED",
            "MESSAGE_QUEUED",
            "MESSAGE_SENT",
            "MESSAGE_DELIVERED",
            "MESSAGE_FAILED",
            "ASSIGNED",
            "STATUS_CHANGED",
            "LINKED",
            "READ",
        ]),
        messageId: zod_1.z.string().uuid().nullable(),
        messageIds: zod_1.z.array(zod_1.z.string().uuid()).max(250).optional(),
        membershipId: zod_1.z.string().uuid().optional(),
    }),
    [exports.BUSINESS_CREATED_EVENT_TYPE]: businessCreatedEventDataSchema,
    [exports.BUSINESS_UPDATED_EVENT_TYPE]: businessUpdatedEventDataSchema,
    [exports.BUSINESS_LOCATION_MANAGEMENT_UPDATED_EVENT_TYPE]: businessScopedDataSchema.extend({ multiLocationEnabled: zod_1.z.boolean() }),
    [exports.BUSINESS_LOCATION_CREATED_EVENT_TYPE]: businessLocationEventDataSchema,
    [exports.BUSINESS_LOCATION_UPDATED_EVENT_TYPE]: businessLocationEventDataSchema,
    [exports.BUSINESS_LOCATION_DEFAULT_CHANGED_EVENT_TYPE]: businessLocationEventDataSchema.extend({
        previousDefaultLocationId: zod_1.z.string().uuid(),
    }),
    [exports.BUSINESS_LOCATION_ARCHIVED_EVENT_TYPE]: businessLocationEventDataSchema,
    [exports.BUSINESS_LOCATION_RESTORED_EVENT_TYPE]: businessLocationEventDataSchema,
    [exports.ORGANIZATION_LOCATION_ACCESS_UPDATED_EVENT_TYPE]: exports.organizationLocationAccessUpdatedEventDataSchema,
    "estimate.created.v1": estimateEventDataSchema,
    "estimate.updated.v1": estimateEventDataSchema,
    "estimate.accepted.v1": estimateEventDataSchema,
    "estimate.declined.v1": estimateEventDataSchema,
    "estimate.version_created.v1": estimateEventDataSchema.extend({
        versionId: zod_1.z.string().uuid(),
        versionNumber: zod_1.z.number().int().positive(),
    }),
    "estimate.delivery_queued.v1": estimateDeliveryEventDataSchema.extend({
        channel: zod_1.z.enum(["EMAIL", "SMS"]),
        versionNumber: zod_1.z.number().int().positive(),
    }),
    "estimate.sent.v1": estimateDeliveryEventDataSchema,
    "estimate.delivery_failed.v1": estimateDeliveryEventDataSchema,
    "estimate.converted.v1": estimateEventDataSchema.extend({
        jobId: zod_1.z.string().uuid(),
    }),
    "estimate.delivered.v1": estimateDeliveryEventDataSchema,
    "estimate.viewed.v1": estimateEventDataSchema.extend({
        deliveryId: zod_1.z.string().uuid().optional(),
        versionId: zod_1.z.string().uuid().optional(),
        customerId: zod_1.z.string().uuid().optional(),
        contactId: zod_1.z.string().uuid().optional(),
    }),
    "portal.invitation_queued.v1": portalMagicLinkEventDataSchema,
    "portal.magic_link_requested.v1": portalMagicLinkEventDataSchema,
    "portal.invitation_sent.v1": portalMagicLinkEventDataSchema,
    "portal.invitation_failed.v1": portalMagicLinkEventDataSchema,
    "portal.access_revoked.v1": portalEventDataSchema.extend({
        accessGrantId: zod_1.z.string().uuid(),
    }),
    "portal.magic_link_exchanged.v1": portalMagicLinkEventDataSchema.extend({
        sessionId: zod_1.z.string().uuid(),
    }),
    "invoice.created.v1": invoiceEventDataSchema,
    "invoice.updated.v1": invoiceEventDataSchema,
    "invoice.issued.v1": invoiceEventDataSchema.extend({
        versionNumber: zod_1.z.number().int().positive(),
    }),
    "invoice.voided.v1": invoiceEventDataSchema,
    [exports.INVOICE_PAID_EVENT_TYPE]: invoiceEventDataSchema.extend({
        paymentId: zod_1.z.string().uuid(),
        amountCents: zod_1.z.number().int().positive(),
    }),
    [exports.INVOICE_VIEWED_EVENT_TYPE]: invoiceEventDataSchema.extend({
        customerId: zod_1.z.string().uuid(),
        contactId: zod_1.z.string().uuid(),
        versionId: zod_1.z.string().uuid(),
        versionNumber: zod_1.z.number().int().positive(),
    }),
    [exports.INVOICE_DELIVERY_QUEUED_EVENT_TYPE]: invoiceDeliveryEventDataSchema.extend({
        versionId: zod_1.z.string().uuid(),
        versionNumber: zod_1.z.number().int().positive(),
        channel: zod_1.z.literal("EMAIL"),
    }),
    [exports.INVOICE_SENT_EVENT_TYPE]: invoiceDeliveryEventDataSchema,
    [exports.INVOICE_DELIVERED_EVENT_TYPE]: invoiceDeliveryEventDataSchema,
    [exports.INVOICE_DELIVERY_FAILED_EVENT_TYPE]: invoiceDeliveryEventDataSchema.extend({
        reasonCode: zod_1.z.string().min(1).max(120),
    }),
    [exports.PAYMENT_RECORDED_EVENT_TYPE]: paymentEventDataSchema,
    [exports.PAYMENT_REVERSED_EVENT_TYPE]: paymentEventDataSchema.extend({
        reversalId: zod_1.z.string().uuid(),
        reason: zod_1.z.string().min(1).max(1_000).optional(),
    }),
    [exports.PAYMENT_FAILED_EVENT_TYPE]: zod_1.z
        .object({
        tenantId: zod_1.z.string().uuid(),
        businessId: zod_1.z.string().uuid(),
        invoiceId: zod_1.z.string().uuid(),
        checkoutSessionId: zod_1.z.string().uuid(),
        reasonCode: zod_1.z.string().min(1).max(120),
    })
        .strict(),
    [exports.PAYMENT_REFUND_FAILED_EVENT_TYPE]: zod_1.z
        .object({
        tenantId: zod_1.z.string().uuid(),
        businessId: zod_1.z.string().uuid(),
        invoiceId: zod_1.z.string().uuid(),
        checkoutSessionId: zod_1.z.string().uuid(),
        refundId: zod_1.z.string().uuid(),
        amountCents: zod_1.z.number().int().positive(),
        reasonCode: zod_1.z.string().min(1).max(120),
    })
        .strict(),
    [exports.PAYMENT_RECONCILIATION_REQUIRED_EVENT_TYPE]: zod_1.z
        .object({
        tenantId: zod_1.z.string().uuid(),
        businessId: zod_1.z.string().uuid(),
        invoiceId: zod_1.z.string().uuid(),
        checkoutSessionId: zod_1.z.string().uuid(),
        reconciliationCaseId: zod_1.z.string().uuid(),
        reason: zod_1.z.enum([
            "AMOUNT_MISMATCH",
            "CURRENCY_MISMATCH",
            "BALANCE_CHANGED",
            "INVOICE_NOT_PAYABLE",
            "DISPUTE_LOST",
        ]),
        expectedAmountCents: zod_1.z.number().int().nonnegative(),
        receivedAmountCents: zod_1.z.number().int().nonnegative(),
        expectedCurrency: zod_1.z.string().length(3),
        receivedCurrency: zod_1.z.string().length(3),
    })
        .strict(),
    [exports.PAYMENT_DISPUTE_UPDATED_EVENT_TYPE]: paymentDisputeEventDataSchema.extend({
        previousStatus: zod_1.z
            .enum(["NEEDS_RESPONSE", "UNDER_REVIEW", "WON", "LOST", "CLOSED"])
            .nullable(),
        source: zod_1.z.enum(["PROVIDER", "STAFF"]),
    }),
    [exports.PAYMENT_DISPUTE_ACTION_REQUIRED_EVENT_TYPE]: paymentDisputeEventDataSchema.extend({
        reason: zod_1.z.enum([
            "NEW_DISPUTE",
            "DEADLINE_APPROACHING",
            "SUBMISSION_FAILED",
        ]),
    }),
    [exports.COMPENSATION_CALCULATION_APPROVED_EVENT_TYPE]: exports.compensationEventDataSchema.extend({ membershipId: zod_1.z.null() }),
    [exports.COMPENSATION_ADJUSTMENT_ADDED_EVENT_TYPE]: exports.compensationEventDataSchema.extend({ membershipId: zod_1.z.string().uuid() }),
    [exports.PREPAYMENT_CREATED_EVENT_TYPE]: prepaymentEventDataSchema.extend({
        requestedAmountCents: zod_1.z.number().int().positive(),
        calculationMode: zod_1.z.enum(["FIXED", "PERCENTAGE"]),
    }),
    [exports.PREPAYMENT_COLLECTED_EVENT_TYPE]: prepaymentEventDataSchema.extend({
        paymentId: zod_1.z.string().uuid(),
        amountCents: zod_1.z.number().int().positive(),
        method: zod_1.z.enum([
            "CASH",
            "CHECK",
            "CARD_EXTERNAL",
            "BANK_TRANSFER",
            "OTHER",
        ]),
    }),
    [exports.PREPAYMENT_COLLECTION_REVERSED_EVENT_TYPE]: prepaymentEventDataSchema.extend({
        paymentId: zod_1.z.string().uuid(),
        reversalId: zod_1.z.string().uuid(),
        reason: zod_1.z.string().min(1).max(1_000),
    }),
    [exports.PREPAYMENT_APPLIED_EVENT_TYPE]: prepaymentEventDataSchema.extend({
        paymentId: zod_1.z.string().uuid(),
        invoiceId: zod_1.z.string().uuid(),
        amountCents: zod_1.z.number().int().positive(),
    }),
    [exports.PREPAYMENT_CANCELED_EVENT_TYPE]: prepaymentEventDataSchema.extend({
        reason: zod_1.z.string().min(1).max(1_000),
    }),
    [exports.CATALOG_ITEM_CREATED_EVENT_TYPE]: catalogItemChangedEventDataSchema.extend({
        itemType: zod_1.z.enum(["SERVICE", "MATERIAL"]),
    }),
    [exports.CATALOG_ITEM_UPDATED_EVENT_TYPE]: catalogItemChangedEventDataSchema,
    [exports.CATALOG_ITEM_ARCHIVED_EVENT_TYPE]: catalogItemEventDataSchema,
    [exports.CATALOG_ITEM_RESTORED_EVENT_TYPE]: catalogItemEventDataSchema,
    [exports.PRICE_BOOK_VERSION_PUBLISHED_EVENT_TYPE]: priceBookVersionEventDataSchema,
    [exports.PRICE_BOOK_VERSION_SCHEDULED_EVENT_TYPE]: priceBookVersionEventDataSchema,
    [exports.CUSTOMER_CREATED_EVENT_TYPE]: customerEventDataSchema.extend({
        customerType: zod_1.z.enum(["RESIDENTIAL", "COMMERCIAL"]),
        primaryServiceLocationId: zod_1.z.string().uuid(),
    }),
    [exports.CUSTOMER_UPDATED_EVENT_TYPE]: customerEventDataSchema.extend({
        changedFields: zod_1.z
            .array(zod_1.z.enum(["type", "displayName", "email", "phone"]))
            .min(1),
    }),
    [exports.CUSTOMER_ARCHIVED_EVENT_TYPE]: customerEventDataSchema,
    [exports.CUSTOMER_CONTACT_CREATED_EVENT_TYPE]: customerContactEventDataSchema.extend({
        roles: zod_1.z.array(customerContactRoleSchema).min(1),
    }),
    [exports.CUSTOMER_CONTACT_UPDATED_EVENT_TYPE]: customerContactEventDataSchema.extend({
        roles: zod_1.z.array(customerContactRoleSchema).min(1),
        smsConsentStatus: zod_1.z.enum(["NOT_REQUESTED", "OPTED_IN", "OPTED_OUT"]),
    }),
    [exports.CUSTOMER_CONTACT_ARCHIVED_EVENT_TYPE]: customerContactEventDataSchema,
    [exports.SERVICE_LOCATION_CREATED_EVENT_TYPE]: customerEventDataSchema.extend({
        serviceLocationId: zod_1.z.string().uuid(),
        isPrimary: zod_1.z.boolean(),
    }),
    [exports.TEAM_MEMBER_INVITED_EVENT_TYPE]: teamMemberInvitedEventDataSchema,
    [exports.TEAM_INVITATION_ACCEPTED_EVENT_TYPE]: teamMembershipEventDataSchema.extend({
        invitationId: zod_1.z.string().uuid(),
        userId: zod_1.z.string().uuid(),
    }),
    [exports.TEAM_MEMBER_ROLE_CHANGED_EVENT_TYPE]: teamMembershipEventDataSchema.extend({
        previousRole: teamRoleSchema,
        role: teamRoleSchema.exclude(["OWNER"]),
    }),
    [exports.TEAM_MEMBER_CAPABILITIES_CHANGED_EVENT_TYPE]: teamMembershipEventDataSchema.extend({
        previousCapabilities: zod_1.z.array(staffCapabilitySchema),
        capabilities: zod_1.z.array(staffCapabilitySchema),
    }),
    [exports.TEAM_MEMBER_STATUS_CHANGED_EVENT_TYPE]: teamMembershipEventDataSchema.extend({
        previousStatus: zod_1.z.enum(["INVITED", "ACTIVE", "INACTIVE"]),
        status: zod_1.z.enum(["ACTIVE", "INACTIVE"]),
    }),
    [exports.TEAM_MEMBER_PROFILE_UPDATED_EVENT_TYPE]: teamMembershipEventDataSchema.extend({
        previousFirstName: zod_1.z.string().nullable().optional(),
        firstName: zod_1.z.string().min(1).max(60).optional(),
        previousLastName: zod_1.z.string().nullable().optional(),
        lastName: zod_1.z.string().min(1).max(59).optional(),
        previousMobilePhone: zod_1.z.string().nullable().optional(),
        mobilePhone: zod_1.z.string().nullable().optional(),
        previousCalendarColor: zod_1.z.string().regex(/^#[0-9A-F]{6}$/),
        calendarColor: zod_1.z.string().regex(/^#[0-9A-F]{6}$/),
        previousTags: zod_1.z.array(zod_1.z.string().min(1).max(32)).max(20),
        tags: zod_1.z.array(zod_1.z.string().min(1).max(32)).max(20),
    }),
    [exports.TEAM_WORKING_HOURS_UPDATED_EVENT_TYPE]: teamMembershipEventDataSchema.extend({
        workingHours: teamWorkingHoursSchema,
    }),
    [exports.JOB_CREATED_EVENT_TYPE]: jobCreatedEventDataSchema,
    [exports.JOB_CREATED_FROM_ESTIMATE_EVENT_TYPE]: jobCreatedFromEstimateEventDataSchema,
    [exports.JOB_UPDATED_EVENT_TYPE]: jobUpdatedEventDataSchema,
    [exports.JOB_STATUS_CHANGED_EVENT_TYPE]: jobStatusChangedEventDataSchema,
    [exports.JOB_LINE_ITEMS_CHANGED_EVENT_TYPE]: jobLineItemsChangedEventDataSchema,
    [exports.JOB_ATTACHMENT_ADDED_EVENT_TYPE]: jobAttachmentEventDataSchema,
    [exports.JOB_ATTACHMENT_REMOVED_EVENT_TYPE]: jobAttachmentEventDataSchema,
    [exports.APPOINTMENT_CREATED_EVENT_TYPE]: appointmentCreatedEventDataSchema,
    [exports.APPOINTMENT_ASSIGNED_EVENT_TYPE]: appointmentAssignedEventDataSchema,
    [exports.APPOINTMENT_STATUS_CHANGED_EVENT_TYPE]: appointmentStatusChangedEventDataSchema,
    [exports.APPOINTMENT_RESCHEDULED_EVENT_TYPE]: appointmentRescheduledEventDataSchema,
    [exports.SCHEDULE_EVENT_CREATED_EVENT_TYPE]: scheduleEventCreatedEventDataSchema,
    [exports.TECHNICIAN_LOCATION_CHANGED_EVENT_TYPE]: businessScopedDataSchema
        .extend({
        locationId: zod_1.z.string().uuid(),
        membershipId: zod_1.z.string().uuid(),
        change: zod_1.z.enum(["STARTED", "POSITION", "STOPPED"]),
    })
        .strip(),
    [exports.SCHEDULE_EVENT_ADDRESS_UPDATED_EVENT_TYPE]: businessScopedDataSchema.extend({
        ...activityActorDataShape,
        businessLocationId: zod_1.z.string().uuid(),
        scheduleEventId: zod_1.z.string().uuid(),
    }),
    [exports.SERVICE_LOCATION_UPDATED_EVENT_TYPE]: customerEventDataSchema.extend({
        serviceLocationId: zod_1.z.string().uuid(),
    }),
};
function parseBuiltInIntegrationEventData(type, data) {
    return builtInEventDataSchemas[type].parse(data);
}
function parseBuiltInIntegrationEvent(input) {
    const envelope = exports.integrationEventEnvelopeSchema.parse(input);
    const type = exports.coreIntegrationEventTypeSchema.parse(envelope.type);
    const data = parseBuiltInIntegrationEventData(type, envelope.data);
    if (data.tenantId !== envelope.tenantId) {
        throw new Error("Event envelope and payload tenantId must match.");
    }
    return { ...envelope, type, data };
}
//# sourceMappingURL=events.js.map